import { IsNotEmpty } from 'class-validator';
import { IAnalyticsActivityEnum } from '../../../../../src/common/enum/analytics-activity/analytics-activity.enum';
import { SelfAppCategoryAveragesSummaryEntity } from '../../../../../src/core/domain/entities/team-metrics/category/self-app-category-average-summary.entity';
import { GetSelfAppCategoryAveragesSummaryResponseDto } from '../../../../../src/interface/dtos/team-metrics/category/get-self-app-category-averages-summary.response.dto';
import { Mapper } from '../../../../common/ddd/mapper.base';
import { formatDuration } from '../../../../common/utils/format-duration.util';

export class ISelfAppCategoryAveragesSummaryEntityPersistenceDto {
  @IsNotEmpty()
  [IAnalyticsActivityEnum.TotalDuration]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.DayCount]: string;
  @IsNotEmpty()
  [IAnalyticsActivityEnum.WeekCount]: string;
}

export class SelfAppCategoryAveragesSummaryEntityMapper
  implements
    Mapper<
      SelfAppCategoryAveragesSummaryEntity,
      GetSelfAppCategoryAveragesSummaryResponseDto
    >
{
  toDomain(
    record: ISelfAppCategoryAveragesSummaryEntityPersistenceDto
  ): SelfAppCategoryAveragesSummaryEntity {
    return SelfAppCategoryAveragesSummaryEntityMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAppCategoryAveragesSummaryEntityPersistenceDto
  ): SelfAppCategoryAveragesSummaryEntity {
    const entity = SelfAppCategoryAveragesSummaryEntity.create({
      totalDuration: Number(record[IAnalyticsActivityEnum.TotalDuration]),
      dayCount: Number(record[IAnalyticsActivityEnum.DayCount]),
      weekCount: Number(record[IAnalyticsActivityEnum.WeekCount]),
    });
    return entity;
  }

  toResponse(
    entity: SelfAppCategoryAveragesSummaryEntity
  ): GetSelfAppCategoryAveragesSummaryResponseDto {
    return SelfAppCategoryAveragesSummaryEntityMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfAppCategoryAveragesSummaryEntity
  ): GetSelfAppCategoryAveragesSummaryResponseDto {
    return {
      averageDailyDuration: Math.round(entity.averageDailyDuration),
      averageWeeklyDuration: Math.round(entity.averageWeeklyDuration),
      formattedAverageDailyDuration: formatDuration(
        entity.averageDailyDuration
      ),
      formattedAverageWeeklyDuration: formatDuration(
        entity.averageWeeklyDuration
      ),
    };
  }
}
